import React from "react";
import { ReactComponent as TitleImage } from "../../../../../assets/svgs/EmpEngagements.svg";
import { THEME_COLORS } from "../../../../../color";

const EmployementEngagement = ({ getComponent, activeDashboard }) => {
  const comp = getComponent ? getComponent("soc_employee_engagement") : null;
  const valDisplay =
    activeDashboard === "live"
      ? comp?.data?.value !== undefined
        ? `${comp.data.value}%`
        : "0%"
      : "82%";

  return (
    <div className="px-5 pb-6 w-full flex-1 flex flex-col justify-between">
      {/* Icon box */}
      <div className="w-12 h-12 mb-4 flex-shrink-0">
        <TitleImage className="w-13 h-13" />
      </div>

      {/* Two Column Layout */}
      <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-4 items-center w-full">
        {/* Left Column: Title */}
        <div className="flex flex-col justify-center pt-2 pl-6">
          <p
            className="font-[Calibri] font-bold text-[24px] sm:text-[28px] leading-tight max-w-[200px]"
            style={{ color: THEME_COLORS.green }}
          >
            Employee
            <br />
            Engagement
          </p>
        </div>

        {/* Right Column: Value & Info */}
        <div className="flex flex-col items-start sm:pl-6">
          {/* Percentage value */}
          <p
            className="text-[55px] sm:text-[70px] font-medium leading-none mb-8 font-calibri"
            style={{ color: THEME_COLORS.green }}
          >
            {valDisplay}
          </p>

          {/* Engaged through block */}
          <div>
            <p
              className="font-bold text-[15px] sm:text-[17px] font-[Calibri] mb-2"
              style={{ color: THEME_COLORS.green }}
            >
              Employee Engaged through
            </p>
            <ul className="list-disc pl-4 space-y-1.5 text-gray-700 font-[Calibri] text-[13px] sm:text-[14px]">
              <li>Fun group activities</li>
              <li>Training and development</li>
              <li>Employee Wellness Programme etc.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployementEngagement;
